import { showCartSuccessModal } from "./cartSuccessModal.js";
import { fetchJson } from "../lib/fetchJson.js";
import { showCartErrorToast } from "../lib/toast.js";

class FFInlineAddButton extends HTMLElement {
  DOM: {
    button: HTMLButtonElement | null
  }

  constructor(){
    super();
    this.DOM = {
      button: this.querySelector("button"),
    }
    this.events()
  }

  events(){
    this.DOM.button?.addEventListener( 'click', this.reserveButtonClick.bind(this) );
    this.DOM.button?.addEventListener( 'addedToCart', this.addedToCart.bind(this) );
	}

  async reserveButtonClick(e: MouseEvent){
		e.preventDefault();
		e.stopPropagation();
		const target = e.currentTarget;
    if( !(target instanceof HTMLElement )) return
		const id = target.dataset.id;
		const quantity = target.dataset.min;

    try {
      await fetchJson("/cart/add.js", {
        method: "POST",
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', },
        body: JSON.stringify({
          quantity: Number(quantity),
          id: id,
        })
      })
      this.reserveSuccess(target)
    } catch (_error) {
      showCartErrorToast()
    }
	}

  reserveSuccess( el: HTMLElement ){
		const event = new CustomEvent('addedToCart')
		el.dispatchEvent(event);
	}

  addedToCart(e: Event){
		const el = e.currentTarget;
    if( !(el instanceof HTMLElement )) return
		const handle = el.dataset.handle;
		showCartSuccessModal(handle || "")
	}

}
customElements.define('ff-inline-add-button', FFInlineAddButton);